export const SUPPORT_PHONE_TEL = '+18887808855';
export const SUPPORT_PHONE_DISPLAY = '(888) 780-8855';
export const SUPPORT_PHONE_INTERNATIONAL = '+1 (888) 780-8855';
export const SUPPORT_PHONE_SCHEMA = '+1-888-780-8855';
export const SUPPORT_PHONE_HREF = `tel:${SUPPORT_PHONE_TEL}`;

export const BUSINESS_CONTACT = {
  phoneDisplay: '(888) 780-8855',
  phoneInternational: '+1 (888) 780-8855',
  phoneHref: 'tel:+18887808855',
  phoneSchema: '+1-888-780-8855',
};

export default BUSINESS_CONTACT;

